<div class="open-street-map-container"
     leaflet
     [leafletOptions]="mapOptions()"
     [leafletMarkerCluster]=""
     [leafletMarkerClusterOptions]="markersClusterOptions()"
     (leafletMapReady)="onMapLoaded($event)"
     (leafletMarkerClusterReady)="onMarkerClusterLoaded($event)"
></div>
